// extracted by mini-css-extract-plugin
module.exports = {"createRecipe_container":"CreateRecipePage_createRecipe_container__1aGIn"};